import React, { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { ChannelPentaActivations, ChannelTypeInfo } from '../UiKit/Channel';
import { FriendsWith } from '../UiKit/FriendsWith';
import { GateAllActivations } from '../UiKit/GateAllActivations';
import { GateInfo } from '../UiKit/GateInfo';
import { Txt } from '../UiKit/Txt';
import { Videos } from '../UiKit/Videos';
import {
  findGateInUser,
  gatherUserChannels,
  handleGateClick
} from '../utilsDesign';
import BodyFocused from '../UiKit/BodyFocused';
import { Background } from '../UiKit/Background';
import ChannelFocused from '../UiKit/ChannelFocused';


export const ChannelInfo = React.memo((props) => {
  const context = { ...useContext(LangContext), ...useContext(SocialContext) };
  const $ui = context.$ui;
  const $channel = context.$channel;
  const $center = context.$center;

  const {
    uniq = '',
    id,
    label = false,
    centers = [],
    circuit = '',
    types = [],
    description,
    gates = [],
    title = '',
    design = {},
    stream = '',
    activatedWith = {},
    className,
    owner,
    penta
  } = { ...props };

  const location = useLocation();
  const navigate = useNavigate();
  const activated1 = Boolean(findGateInUser(design.gates, gates[0]).length);
  const activated2 = Boolean(findGateInUser(design.gates, gates[1]).length);

  return (<>

    <div className="x_info_section">
      <div className="x_edu_study_channel_preview x_info_w _fcc">
        <ChannelFocused
          design={design}
          // focus={gates}
          highlightedGate={gates}
          style={{
            height: '9em',
            width: '28em', 
          // marginTop: '-1em'
          // borderRadiusTopLeft: 10
        }} />
        <Background
          // style={{ zIndex: -1 }}
          aura={false}
          design={design}
        />
      </div>
    </div>

    <div className="_fv _fgap1">
      <div className="x_info_section">
        <div className="x_info_w">

          <div className="x_info_title ">
            <div className="x_edu_channel_title0">
              <div className="x_edu_channel_title">
                <div className="x_edu_channel_h1">
                  {context.languageReady && <><span className="x_edu_channel_of _tnowrap">{$ui('channel_of')}</span>  {$channel(id, 'title')}</>}
                  {!context.languageReady && id}
                </div>
              </div>
              <div className="x_edu_item_desc">
                <Txt>{$channel(id, 'description')}</Txt>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div className="x_info_section x_info_w">
        <ChannelTypeInfo
          // className='x_info_w'
          {...props}
        />
      </div>

      <div className="x_info_section">
        <div className="x_info_w">
          <Videos
            // style={{ width: '100%' }}
            title={`${gates[0]}–${gates[1]} ${$channel(id, 'title')}`}
            size='sm'
            relType='channels'
            relValue={id} />
        </div>
      </div>

      <div className="x_info_section">
        {design && design.gates && <div className='_fv'>
          <div className="x_info_w">
            <div className="x_info_subtitle">
              {$ui('edu_channel_activations')}
            </div>

            {penta ? (
              gates.map((gateId) => {
                const activated = Boolean(findGateInUser(design.gates, gateId).length);
                return (
                  <div
                    key={`penta_gate_${gateId}`}
                    className={`x_edu_chan x_info_gate0 ${activated ? '' : 'x_info_gate0--0'}`}
                    style={activated ? undefined : { paddingRight: 0 }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleGateClick(gateId, location, navigate);
                    }}
                  >
                    <div className={`_fv ${activated ? '_fgap06' : '_fl _f100'}`}>
                      <GateInfo
                        design={design}
                        number={true}
                        title={true}
                        hexagram={true}
                        description={true}
                        gateId={gateId}
                        activated={activated}
                      />
                      {activated ? (
                        <ChannelPentaActivations
                          penta={penta}
                          gates={[gateId]}
                          number={false}
                          hexagram={false}
                          stack={true}
                        />
                      ) : (
                        <div className="x_edu_badge x_edu_badge--open">
                          {$ui('edu_gate_no_activations')}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })
            ) : (
              <>
                {activated1 &&
                  <div className='x_edu_chan x_info_gate0'
                    onClick={(e) => {
                      e.stopPropagation();
                      handleGateClick(gates[0], location, navigate);
                    }}
                  >
                    <div className="_fv _fgap06">
                      <GateInfo
                        design={design}
                        number={true}
                        title={true}
                        hexagram={true}
                        description={true}
                        gateId={gates[0]}
                        activated={activated1}
                      />
                      <GateAllActivations
                        number={false}
                        design={design}
                        gateId={gates[0]}
                        planetGlyph={false}
                        activated={activated1}
                      />
                    </div>
                  </div>}

                {activated2 &&
                  <div className='x_edu_chan x_info_gate0'
                    onClick={(e) => {
                      e.stopPropagation();
                      handleGateClick(gates[1], location, navigate);
                    }}
                  >
                    <div className="_fv _fgap06">
                      <GateInfo
                        design={design}
                        number={true}
                        hexagram={true}
                        title={true}
                        description={true}
                        gateId={gates[1]}
                        activated={activated2}
                      />
                      <GateAllActivations
                        number={false}
                        design={design}
                        gateId={gates[1]}
                        activated={activated2}
                      />
                    </div>
                  </div>}

                {!activated1 &&
                  <div className='x_edu_chan x_info_gate0 x_info_gate0--0' style={{ paddingRight: 0 }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleGateClick(gates[0], location, navigate);
                    }}
                  >
                    <div className="_fv _fl _f100">
                      <GateInfo
                        design={design}
                        number={true}
                        hexagram={true}
                        title={true}
                        description={true}
                        gateId={gates[0]}
                        activated={activated1}
                      />
                      <div className="x_edu_badge x_edu_badge--open">
                        {$ui('edu_gate_no_activations')}
                      </div>
                      {Boolean(context.me) && <FriendsWith
                        size=''
                        titleAfter={<b>{$ui('edu_gate_activated_in')}</b>}
                        filterCase={a => a.filter(one => design && findGateInUser(one.avatar.design.gates, gates[0]).length)}
                      />}
                    </div>
                  </div>}

                {!activated2 &&
                  <div className='x_edu_chan x_info_gate0 x_info_gate0--0' style={{ paddingRight: 0 }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleGateClick(gates[1], location, navigate);
                    }}
                  >
                    <div className="_fv  _fl _f100">
                      <GateInfo
                        design={design}
                        number={true}
                        hexagram={true}
                        title={true}
                        description={true}
                        gateId={gates[1]}
                        activated={activated2}
                      />
                      <div className="x_edu_badge x_edu_badge--open">
                        {$ui('edu_gate_no_activations')}
                      </div>
                      {Boolean(context.me) && <FriendsWith
                        size=''
                        titleAfter={<b>{$ui('edu_gate_activated_in')}</b>}
                        filterCase={a => a.filter(one => design && findGateInUser(one.avatar.design.gates, gates[1]).length)}
                      />}
                    </div>
                  </div>}
              </>
            )}
          </div>
        </div>}
      </div>
    </div>
    {context.me && (
       context.celebs || ( context.followings && context.followers) )
      && <div className="x_info_section _fv _f100 _fr ">
        <div className="x_info_w">
          <FriendsWith
            // titleAfter={<b><span className="x_edu_channel_of">{$ui('channel_of')}</span>  {$channel(id, 'title')}</b>}
            titleAfter={<b>{`${gates[0]}-${gates[1]}`}</b>}
            size='lg'
            // globally={<>{$center(center, 'percentage_defined')}%</>}
            filterCase={a => a.filter(one => {
              const ch = gatherUserChannels(one.avatar.design.gates).map(one => one.id)
              return ch.includes(id)
            })}
          />
        </div>
      </div>}
  </>)
})